import { Link } from "react-router-dom";
import { IMAGE_URL } from "../../config/Config";

const Ad = ({ banner, link }) => {
    return banner && link ? <Link className="d-flex" target="_blank" rel="noreferrer" to={{ pathname: link }}>
        <img className="m-auto pb-3 awards-image" src={`${IMAGE_URL}${banner}`} alt="ad" />
    </Link> : null;
};

export default Ad;
